import Store from "$common/utils/store";
export default commomImport => [{
  path: `refund-order`,
  name: 'refundOrder',
  meta: {
    title: ('store.refundOrder'),
    nameCount: 'applying',
    noCache: true
  },
  //  全部订单
  component: commomImport('order-manager/refund-order')
}];
